import { TextField } from '@qbe/ads-core';
import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

import { useAppContent } from '~/hooks';

interface MobileNumberProps<T extends FieldValues> extends UseControllerProps<T> {}

const mobileNumberPattern = /^0\d{9}$/;
const maxLength = 10;

const MobileNumber = <T extends FieldValues>({ control, name }: MobileNumberProps<T>) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.contactDetailsComponent.fields.mobileNumber',
  });
  return (
    <Controller
      name={name}
      control={control}
      rules={{ pattern: mobileNumberPattern, required: true, maxLength }}
      render={({ field: { ref, ...field }, fieldState }) => (
        <TextField
          {...field}
          id="mobileNumber"
          inputRef={ref}
          label={getTextContent('label')}
          data-track-value="mask"
          helperText={
            fieldState.invalid ? getTextContent('invalidText') : getTextContent('helperText')
          }
          type="tel"
          error={fieldState.invalid}
          displayIcon
          required
        />
      )}
    />
  );
};

export default MobileNumber;
